
'use strict'

import { changeForm } from './cartDetail';



export function initInScope($scope) {
    const url = $scope.find('.discount-code__js').data('url');
    const $form = $scope.find('.js-cart-detail__form');

    $("body").on('click', '.discount-apply__js', function () {
        submitDiscountCode();
    });

    $('body').on('keydown', '.discount-code__js', function (event) {
        if (event.key === 'Enter') {
            submitDiscountCode();
        }
    });


    $("body").on("click", ".discount-remove__js", function () {
        const removeUrl = $(this).data('url');
        $.ajax({
            url: removeUrl,
            type: "POST",
            success: (data) => {
                if (window.location.pathname.includes('/cart/detail')) {
                    changeForm($form);
                }
                else {
                    window.location.reload();
                }
            },
            error: (xhr, status, error) => {
                console.error("Error:", error);
            }
        });
    });

    function submitDiscountCode() {
        const code = $scope.find('.discount-code__js').val();
        let cartUrl = "checkout";
        if (window.location.pathname.includes('/cart/detail'))
            cartUrl = "cart";
        if (url) {
            $.ajax({
                url: url,
                type: "POST",
                data: {
                    "discountCode": code,
                    "cartUrl": cartUrl 
                },
                success: (data) => {
                    if (!data.success) {
                        $scope.find('.discount-code__js').parent().find(".form-errors").html(data.message);
                        return;
                    }
                    if (data.success) {
                        if (window.location.pathname.includes('/cart/detail')) {
                            $scope.find('.discount-code__js').parent().find(".form-errors").html('');
                            changeForm($form);
                        }
                        else {
                            window.location.reload();
                        }
                    }
                    console.log(data);
                },
                error: (xhr, status, error) => {
                    console.error("Error:", error);
                }
            });
        }
    }
}
